import { Edit, Refresh } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionGroup, AccordionSummary, Button, Input } from '@mui/joy';
import { FC, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useAuth } from '../../providers/AuthContext';

interface RateProps {
    // Define component props here
}

const Rate: FC<RateProps> = () => {
    const auth = useAuth();
    const [rate, setRate] = useState(0)
    const [loading, setLoading] = useState(false)
    const [refreshLoading, setRefreshLoading] = useState(false)
    const fetchRate = async () => {
        setRefreshLoading(true)
        const response = await fetch(`${process.env.REACT_APP_server}/mileage/rate`, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            method: 'PATCH'
        });
        setRefreshLoading(false)

        const data = await response.json();

        setRate(Number(data?.data) || 0)
    }
    useEffect(() => {
        fetchRate()
    }, [])
    async function handleRate(e: any) {
        setLoading(true)
        const response = await fetch(process.env.REACT_APP_server + "/mileage/rate", {
            headers: {
                'Content-type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
            method: 'POST',
            body: JSON.stringify({ rate })
        })

        const data = await response.json()
        setLoading(false)
        if (data.error) {
            toast.error(data.message);
            return;
        }
        toast.success("Rate updated");
    }

    if (auth?.user?.role === 'admin') {
        return (
            <AccordionGroup transition={'0.2s ease'} sx={{
                width: '50%'
            }}>
                <Accordion>

                    <AccordionSummary indicator={<Edit />} >Edit Rate of Mileage</AccordionSummary>
                    <AccordionDetails sx={{ mt: 1 }}>
                        <div style={{
                            display: 'flex',
                            gap: 10
                        }}>
                            <Input disabled={refreshLoading || loading} type='number' value={rate.toString()} onChange={(e) => {
                                setRate(Number(e.target.value))
                            }} />
                            <Button loading={refreshLoading} onClick={fetchRate}><Refresh /></Button>
                        </div>
                        <Button loading={loading} disabled={refreshLoading} sx={{
                            mt: 3
                        }} onClick={handleRate}>Edit Rate</Button>
                    </AccordionDetails>
                </Accordion>
            </AccordionGroup>
        );
    }
    return <></>

};

export default Rate;